import React from 'react';
import { motion } from 'framer-motion';
const bonuses = [{
  title: 'Bono 1 — Guía de Prompts que Venden',
  desc: 'Estructura exacta de cómo escribir prompts con lógica comercial para ropa.'
}, {
  title: 'Bono 2 — 50 Ideas de Nichos Listos para Vender',
  desc: 'Lista validada para que no pierdas tiempo pensando qué crear.'
}, {
  title: 'Bono 3 — Sistema de Validación Rápida',
  desc: 'Cómo saber si un diseño tiene potencial antes de perder tiempo.'
}, {
  title: 'Bono 4 — Guía Anti-Bloqueo Creativo',
  desc: 'Sistema para nunca quedarte sin ideas.'
}, {
  title: 'Bono 5 — Script de Venta para Diseños',
  desc: 'Cómo presentar y vender tus diseños online.'
}, {
  title: 'Bono 6 — Pack de Mockups para Ropa',
  desc: 'Recursos visuales listos para mostrar tus diseños.'
}];
export function BonusSection() {
  return <section className="py-12 md:py-24 bg-neutral-950" data-id="element-1">
      <div className="container mx-auto px-4" data-id="element-2">
        <div className="text-center mb-8 md:mb-16" data-id="element-3">
          <motion.div initial={{
          opacity: 0,
          scale: 0.8
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} className="inline-block bg-brand-500 text-white font-bold px-4 py-1 rounded-full text-sm uppercase tracking-wider mb-4 md:mb-6" data-id="element-4">
            GRATIS POR HOY
          </motion.div>
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="font-bebas text-5xl md:text-6xl text-white uppercase tracking-wide" data-id="element-5">
            Bonos <span className="text-brand-500" data-id="element-6">Exclusivos</span>
          </motion.h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3 md:gap-6 max-w-6xl mx-auto mb-8 md:mb-16" data-id="element-7">
          {bonuses.map((bonus, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.1
        }} className="bg-neutral-900 border border-brand-500/20 rounded-xl p-6 relative overflow-hidden group" data-id="element-8">
              <div className="absolute top-0 right-0 w-24 h-24 bg-brand-500/10 rounded-bl-full -mr-4 -mt-4 transition-transform group-hover:scale-110" data-id="element-9" />
              <div className="text-3xl mb-4 relative z-10" data-id="element-10">🎁</div>
              <h3 className="text-lg font-bold text-white mb-2 relative z-10" data-id="element-11">
                {bonus.title}
              </h3>
              <p className="text-neutral-400 text-sm relative z-10" data-id="element-12">
                {bonus.desc}
              </p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="max-w-md mx-auto text-center bg-neutral-900 border border-neutral-800 rounded-2xl p-8" data-id="element-13">
          <p className="text-neutral-400 mb-2" data-id="element-14">Valor total de los bonos:</p>
          <p className="text-3xl text-neutral-500 line-through font-bold mb-2" data-id="element-15">
            $60.000 ARS
          </p>
          <p className="text-4xl font-bebas text-brand-500 tracking-wide mb-8" data-id="element-16">
            Por hoy → GRATIS
          </p>

          <a href="https://checkout.promptwearr.shop/cart/44479124242567:1" className="inline-block text-brand-500 font-bold hover:text-brand-400 transition-colors uppercase tracking-wider" data-id="element-17">
            👉 Acceder a Prompt Wear ahora
          </a>
        </motion.div>
      </div>
    </section>;
}